// components/Hero.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faArrowRight,
  faBuilding,
  faAward,
  faCompassDrafting
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section id="home" className="relative h-screen w-full overflow-hidden flex flex-col justify-center">
      
      {/* --- BACKGROUND LAYER --- */}
      <div className="absolute inset-0 z-0">
        {/* Main Image with Slow Zoom Effect */}
        <div className="absolute inset-0 bg-black overflow-hidden">
          <img 
            src="https://images.unsplash.com/photo-1563569612948-9bd14a098036?q=80&w=1332&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt="Luxury Architecture"
            className="w-full h-full object-cover opacity-80 scale-105 animate-[subtle-zoom_20s_infinite_alternate]"
          />
        </div>
        
        {/* Sophisticated Gradient Overlay */}
        {/* Darker at bottom for text readability, clearer at top */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/10 to-black/30"></div>
        
        {/* Texture Overlay (Grain) */}
        <div className="absolute inset-0 opacity-[0.03]" 
             style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")` }}>
        </div>
      </div>

      {/* --- MAIN CONTENT --- */}
      <div className="relative z-10 container mx-auto px-6 lg:px-16 flex flex-col h-full justify-center">
        
        <div className="max-w-4xl space-y-8 mt-10">
          
          {/* Badge / Tagline */}
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm border border-white/10 px-4 py-2 rounded-full animate-[fadeInDown_1s_ease-out]">
            <span className="w-2 h-2 rounded-full bg-yellow-500 animate-pulse"></span>
            <span className="text-yellow-500 text-xs font-bold tracking-widest uppercase">
              Premium Construction
            </span>
          </div>

          {/* Heading */}
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-light text-white leading-[1.1] tracking-tight animate-[fadeInUp_1s_ease-out_0.3s_both]">
            Building Beyond <br />
            <span className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-white via-gray-200 to-gray-200">
              The Blueprint.
            </span>
          </h1>

          {/* Subtext */}
          <p className="text-lg md:text-xl text-white max-w-2xl leading-relaxed font-light animate-[fadeInUp_1s_ease-out_0.5s_both] border-l-2 border-yellow-500/50 pl-6">
            We architect spaces that tell stories. Each project is a symphony of 
            design, craftsmanship, and innovation, creating homes that stand as 
            timeless landmarks in a modern world.
          </p>

          {/* CTA Area */}
          <div className="flex flex-col sm:flex-row gap-5 pt-4 animate-[fadeInUp_1s_ease-out_0.7s_both]">
            <Link to='/contact'>
            <button className="group relative overflow-hidden bg-white text-black px-10 py-5 rounded-full font-bold text-lg transition-all duration-300 hover:shadow-[0_0_40px_-10px_rgba(255,255,255,0.5)] hover:scale-105">
              <span className="relative z-10 flex items-center">
                Start Your Project
                <FontAwesomeIcon icon={faArrowRight} className="ml-3 group-hover:translate-x-1 transition-transform" />
              </span>
              <div className="absolute inset-0 bg-gray-200 transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-500 ease-out"></div>
            </button>
            </Link>
            
           
          </div>
        </div>
      </div>

     

      {/* Custom Styles for Animations (You can add this to your tailwind.config.js or CSS file) */}
      <style jsx>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes subtle-zoom {
          0% { transform: scale(1); }
          100% { transform: scale(1.1); }
        }
      `}</style>
    </section>
  );
};

export default Hero;